import { render, staticRenderFns } from "./GridSharedAccess.vue?vue&type=template&id=29396901&"
import script from "./GridSharedAccess.vue?vue&type=script&lang=js&"
export * from "./GridSharedAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29396901')) {
      api.createRecord('29396901', component.options)
    } else {
      api.reload('29396901', component.options)
    }
    module.hot.accept("./GridSharedAccess.vue?vue&type=template&id=29396901&", function () {
      api.rerender('29396901', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/shared-access/grid/GridSharedAccess.vue"
export default component.exports